// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.down-blue-button_button__Qo8Nz {
  grid-column: 1 / span 2; /* Span both columns */
  justify-self: center; /* Center within the grid cell */
  margin-top: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%; /* Make the button circular */
  border: 4px solid var(--Colors-Blue, #007AFF); /* Blue border */
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  animation: down-blue-button_arrowBounce__fNbXn 1s infinite; /* Infinite animation */
  cursor: pointer;
}
.down-blue-button_button__Qo8Nz:disabled,
.down-blue-button_button__Qo8Nz:disabled:hover,
.down-blue-button_button__Qo8Nz:disabled:active
 {
border: 4px solid var(--Colors-Blue, #007AFFB2); /* Blue border */
  cursor: auto;
}
.down-blue-button_button__Qo8Nz:disabled .down-blue-button_icon__H570R {
  color: var(--Colors-Blue, #007AFFB2); /* Blue icon */
}

/* Style for the arrow icon */
.down-blue-button_icon__H570R {
  font-size: 30px; /* Adjust the size of the arrow */
  color: var(--Colors-Blue, #007AFF); /* Match the color */
  position: absolute;
}

/* Keyframes for the arrow animation */
@keyframes down-blue-button_arrowBounce__fNbXn {
  0% {
    transform: translateY(0); /* Start at the top */
    opacity: 1;
  }
  100% {
    transform: translateY(7px); /* Move down */
    opacity: 0.5;
  }
 
}

@media (max-width: 768px) { /* Adjust breakpoint as needed */
  .down-blue-button_button__Qo8Nz {
    grid-column: auto; /* Remove column spanning */
    justify-self: center; /* Center within the single column */
  }
}

.down-blue-button_spinner__X\\+ziX {
  animation: down-blue-button_spin__PDkUx 1s linear infinite; /* Rotates the spinner */
}

/* Keyframes for rotation */
@keyframes down-blue-button_spin__PDkUx {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/UI/common/Buttons/down-blue-button.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB,EAAE,sBAAsB;EAC/C,oBAAoB,EAAE,gCAAgC;EACtD,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE,6BAA6B;EACjD,6CAA6C,EAAE,gBAAgB;EAC/D,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0DAAkC,EAAE,uBAAuB;EAC3D,eAAe;AACjB;AACA;;;;AAIA,+CAA+C,EAAE,gBAAgB;EAC/D,YAAY;AACd;AACA;EACE,oCAAoC,EAAE,cAAc;AACtD;;AAEA,6BAA6B;AAC7B;EACE,eAAe,EAAE,iCAAiC;EAClD,kCAAkC,EAAE,oBAAoB;EACxD,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE;IACE,wBAAwB,EAAE,qBAAqB;IAC/C,UAAU;EACZ;EACA;IACE,0BAA0B,EAAE,cAAc;IAC1C,YAAY;EACd;;AAEF;;AAEA,4BAA4B,gCAAgC;EAC1D;IACE,iBAAiB,EAAE,2BAA2B;IAC9C,oBAAoB,EAAE,oCAAoC;EAC5D;AACF;;AAEA;EACE,0DAAkC,EAAE,wBAAwB;AAC9D;;AAEA,2BAA2B;AAC3B;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".button {\n  grid-column: 1 / span 2; /* Span both columns */\n  justify-self: center; /* Center within the grid cell */\n  margin-top: 30px;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%; /* Make the button circular */\n  border: 4px solid var(--Colors-Blue, #007AFF); /* Blue border */\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  animation: arrowBounce 1s infinite; /* Infinite animation */\n  cursor: pointer;\n}\n.button:disabled,\n.button:disabled:hover,\n.button:disabled:active\n {\nborder: 4px solid var(--Colors-Blue, #007AFFB2); /* Blue border */\n  cursor: auto;\n}\n.button:disabled .icon {\n  color: var(--Colors-Blue, #007AFFB2); /* Blue icon */\n}\n\n/* Style for the arrow icon */\n.icon {\n  font-size: 30px; /* Adjust the size of the arrow */\n  color: var(--Colors-Blue, #007AFF); /* Match the color */\n  position: absolute;\n}\n\n/* Keyframes for the arrow animation */\n@keyframes arrowBounce {\n  0% {\n    transform: translateY(0); /* Start at the top */\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(7px); /* Move down */\n    opacity: 0.5;\n  }\n \n}\n\n@media (max-width: 768px) { /* Adjust breakpoint as needed */\n  .button {\n    grid-column: auto; /* Remove column spanning */\n    justify-self: center; /* Center within the single column */\n  }\n}\n\n.spinner {\n  animation: spin 1s linear infinite; /* Rotates the spinner */\n}\n\n/* Keyframes for rotation */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `down-blue-button_button__Qo8Nz`,
	"arrowBounce": `down-blue-button_arrowBounce__fNbXn`,
	"icon": `down-blue-button_icon__H570R`,
	"spinner": `down-blue-button_spinner__X+ziX`,
	"spin": `down-blue-button_spin__PDkUx`
};
export default ___CSS_LOADER_EXPORT___;
